import type { messages } from '@prisma/client';
import api from '../api';

export type Message = messages;

const messagesService = {
  /** Buyer-mode outreach thread for a deal (empty array in platform mode). */
  find: async (dealId: string): Promise<Message[]> => {
    const response = await api.get<Message[]>('/messages', {
      params: { dealId },
    });
    return response.data;
  },
};

export default messagesService;
